'use strict';

var d3tip = require('d3-tip');
var d3 = require('d3');
var $ = require('jquery');
var _ = require('lodash');
var Tooltip = function Tooltip() {
  /**
   * @param tooltipHandler - a function that returns HTML content of the tooltip
   * @returns {Function}
   * @constructor
   */
  return function (tooltipHandler, tooltipClass) {
    var tooltip = d3tip().attr('class', 'd3-tip d3-chart-tooltip' + (tooltipClass ? ' ' + tooltipClass : '')).html(tooltipHandler);

    /**
     * Default implementation of positioning of tooltip near cursor
     * @param tooltipSelector
     */
    tooltip.setPositionNearCursor = function (tooltipSelector) {
      var pageX = d3.event.pageX;
      var pageY = d3.event.pageY;
      var html = $('html');
      var pageWidth = html.width();
      var pageHeight = html.height();
      var tooltipOuterWidth = $(tooltipSelector).outerWidth();
      var tooltipOuterHeight = $(tooltipSelector).outerHeight();

      // Setting tooltip offset with relation to mouse cursor
      var left = pageX + 20;
      var top = pageY + 20;

      // Change tooltip orientation when mouse position goes beyond: tooltip width + offset + extra space(30px)
      if (pageX > pageWidth - tooltipOuterWidth - 20 - 30) {
        left = pageX - tooltipOuterWidth - 10;
      }

      // Change tooltip orientation when mouse position goes beyond: tooltip height + offset + extra space(30px)
      if (pageY > pageHeight - tooltipOuterHeight - 20 - 30) {
        top = pageY - tooltipOuterHeight - 10;
      }
      tooltip.style('top', top + 'px');
      tooltip.style('left', left + 'px');
    };
    tooltip.showAndAdjustPosition = function (data, rootElement) {
      tooltip.show(data, rootElement);
      if (_.startsWith(tooltip.style('top'), '-')) {
        tooltip.style('top', 0);
      }
      return tooltip;
    };
    tooltip.hideAndAdjustPosition = function () {
      tooltip.hide() // move invisible tooltip to the left-top corner
      .style({
        top: '0px',
        left: '0px'
      });
      return tooltip;
    };
    return tooltip;
  };
};
Tooltip.$inject = [];
module.exports = Tooltip;